export default {"src":"/_next/static/media/college10.56c1b987.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};